'use client'

import { Button, type ButtonButtonProps } from '@algoacademy/design-system/web/actions/Button'
import type React from 'react'
import { forwardRef } from 'react'
import { useWaitlistSignup } from './WaitlistSignupContext'

export type WaitlistButtonProps = ButtonButtonProps & {
  waitlistProductInterest?: string
}

/**
 * {@link Button} styling that opens the marketing waitlist signup dialog. Use only under
 * {@link WaitlistSignupProvider}.
 */
export const WaitlistButton = forwardRef<HTMLElement, WaitlistButtonProps>(function WaitlistButton(
  { waitlistProductInterest, onClick, ...buttonProps },
  ref
) {
  const { open } = useWaitlistSignup()

  return (
    <Button
      ref={ref}
      {...buttonProps}
      onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
        onClick?.(e)
        if (!e.defaultPrevented) {
          open(waitlistProductInterest)
        }
      }}
    />
  )
})
